import type { JobPost } from "@workspace/api-client-react";

export function isActionableReferral(job: JobPost): boolean {
  return job.referralAvailable === true && job.authorProfileId !== undefined;
}